/**
 * @Author : DingHuiHui
 * @Content : 投资回报-报表接口配置
 */
import $http from '@/utils/requestAxios'

export const apiRoi = {
  // 机器人数
  robot (params) {
    return $http.get('/reward/robot-amount', params, {}, 'report')
  },
  // 机器人运行时长
  robotTime (params) {
    return $http.get('/reward/robot-time', params, {}, 'report')
  },
  // 投资回报分析
  investLine (params) {
    return $http.get('/reward/analysis', params, {}, 'report')
  },
  // 任务日志
  task (params, page = 1, size = 10) {
    return $http.get('/reward/job-logs', { ...params, page, size }, {}, 'report')
  }
}
